export const convertNotificationList = (data) => {
  let converted = [];

  data.forEach((item) => {
    converted.push({
      value: item.id,
      label: item.name,
    });
  });
  return converted;
};
